import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Product_Attribute_Group_Search_Fields: {[id: string]: ISearchProviderField} = {
    WB_PRDATTRGRP_ID:             {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Product Attr Group Id',    columnResourceName: 'colId',               alignment: HorizAlignment.Left},  domainOptions: {}},
    ATTRIB_GROUP_ID:              {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Attrib Group Id',             columnResourceName: 'colId',               alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    ATTRIB_GROUP_NAME:            {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Attrib Group Name',           columnResourceName: 'colLName',            alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    TREEPATH:                     {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'TreePath',                    columnResourceName: 'colTreePath',         alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CNSPRDDIM_IND:                {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Consumer Product Ind',        columnResourceName: 'colCnsPrdInd',        alignment: HorizAlignment.Left},  domainOptions: {}},
    CNSPRDDIM_ID_FIELDNAME:       {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Consumer ID FieldName',       columnResourceName: 'colCnsIdFldName',     alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CNSPRDDIM_NAME_FIELDNAME:     {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Consumer Name FieldName',     columnResourceName: 'colCnsNameFldName',   alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CREATED_DTTS:                 {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Created Date',                columnResourceName: 'colCreatedDate',      alignment: HorizAlignment.Left},  domainOptions: {}},
    MODIFIED_DTTS:                {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Created Date',                columnResourceName: 'colModifiedDate',     alignment: HorizAlignment.Left},  domainOptions: {}},
    DELETED_IND:                  {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Deleted Ind',                 columnResourceName: 'colDeletedInd',       alignment: HorizAlignment.Left},  domainOptions: {}},
    DELETED_DT:                   {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Deleted Date',                columnResourceName: 'colDeleted_Date',     alignment: HorizAlignment.Left},  domainOptions: {}}
};

const ProductAttributeGroupSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_PRDATTRGRP_ID',
        id_ui: 'ATTRIB_GROUP_ID',
        name: 'ATTRIB_GROUP_NAME'
    },

    searchProviderFields: vUI_Product_Attribute_Group_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Product_Attribute_Group_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res:any)=>{
                    resolve(res)
                })
                .catch((err)=>{
                    error(err)
                })
        })
    }

};

const ProductAttributeGroupSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "ProductAttributeGroupSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'ATTRIB_GROUP_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'ATTRIB_GROUP_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'ATTRIB_GROUP_ID', 'ATTRIB_GROUP_NAME', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductAttributeGroupSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ProductAttributeGroupSearch: ISearch = {
    searchName: "Find Product Attribute Group",
    renderOptions: {ui5ResourceId: "ProductAttributeGroupSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ProductAttributeGroupSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("ProductAttributeGroupBO", "ProductAttributeGroup", ProductAttributeGroupSearch, "Product Attribute Group Search")

export {ProductAttributeGroupSearch}